var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.shown)?_vm._t("display",null,{"show":_vm.open}):_vm._e(),(_vm.shown)?_vm._t("content",null,{"close":_vm.close}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }